// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq-module--faq--ouBIs","faq__item":"faq-module--faq__item--2mnmB","faq__question":"faq-module--faq__question--3J_F2"};